import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from 'ui/Button';
import Text from 'ui/Text';
import theme from 'ui/theme/theme';

import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
} from '@chakra-ui/react';

function ConfirmCloseModal({ isOpen, onClose }) {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay bg="rgba(27, 27, 27, 0.75)" />
        <ModalContent>
          <ModalHeader bg="gray.100">
            <Text fontWeight="bold">Are you sure?</Text>
          </ModalHeader>
          <ModalCloseButton
            onClick={() => {
              onClose();
            }}
          />
          <ModalBody padding="5px 10px">
            <Flex
              flexDirection="column"
              justifyContent="space-around"
              alignItems="center"
            >
              <Text
                my="24px"
                textAlign="center"
                color={theme.colors.gray['500']}
              >
                {` By closing this page, you'll lose all the data you've entered on this
                page.`}
              </Text>
            </Flex>
            <Divider color="gray.300" />
          </ModalBody>
          <ModalFooter
            flexDirection={{ base: 'column-reverse', md: 'row' }}
            justifyContent={{ base: '', md: 'right' }}
          >
            <Flex marginTop={{ sm: '20px', md: '0' }}>
              <Button
                variant="secondary-1"
                mr={{ md: '20px', sm: '0' }}
                width={{ sm: '88vw', md: 'auto' }}
                onClick={onClose}
              >
                Cancel
              </Button>
            </Flex>
            <Flex marginTop={{ sm: '20px', md: '0' }}>
              <Link to="/fgm">
                <Button
                  variant="primary-1"
                  mr={{ md: '20px', sm: '0' }}
                  width={{ sm: '88vw', md: 'auto' }}
                >
                  Leave this page
                </Button>
              </Link>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

ConfirmCloseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmCloseModal;
